import { Link } from 'react-router-dom'
import { ROUTES } from '@/routes'

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <p className="text-6xl font-bold text-kasa-green-600">404</p>
      <h1 className="mt-4 text-2xl font-semibold text-gray-900">
        Page not found
      </h1>
      <p className="mt-2 text-sm text-gray-500">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to={ROUTES.home}
        className="mt-8 rounded-lg bg-kasa-green-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-kasa-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kasa-green-600"
      >
        Back to home
      </Link>
    </div>
  )
}
